module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    class: [_vm.color, {
      opened: _vm.dropdownOpened
    }]
  }, [_c('div', {
    staticClass: "container"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dropdownOpened),
      expression: "!dropdownOpened"
    }],
    staticClass: "nav"
  }, [_vm._l((_vm.menu), function(key) {
    return _c('router-link', {
      key: key,
      staticClass: "menu",
      attrs: {
        "to": _vm.$store.state.links[key].url
      }
    }, [_vm._v(_vm._s(_vm.$t(_vm.$store.state.links[key].name)))])
  }), (!!_vm.$store.state.category) ? _c('span', {
    staticClass: "current-category"
  }, [_vm._v(_vm._s(_vm.$store.state.category.name[_vm.$i18n.locale]))]) : _vm._e()], 2)]), _c('div', {
    staticClass: "logo"
  }, [_c('router-link', {
    staticClass: "menu bold",
    attrs: {
      "to": _vm.$store.state.links.main.url
    },
    nativeOn: {
      "close": function($event) {
        _vm.changeDropdownState(false)
      }
    }
  }, [_vm._v("Sota.")])], 1), _c('div', {
    staticClass: "icon",
    on: {
      "click": function($event) {
        _vm.changeDropdownState(!_vm.dropdownOpened)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "25",
      "height": "25",
      "viewBox": "0 0 25 25"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.dropdownOpened) ? _c('path', {
    key: "open",
    attrs: {
      "fill": "#000",
      "fill-rule": "evenodd",
      "d": "M1 5.5h23v2H1v-2zm0 6h23v2H1v-2zm0 6h23v2H1v-2z"
    }
  }) : _c('g', {
    key: "close",
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke": "#000",
      "stroke-width": "1.5"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5 5l15 15M5 20L20 5"
    }
  })])])], 1)])], 1)]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dropdownOpened),
      expression: "dropdownOpened"
    }],
    staticClass: "dropdown",
    attrs: {
      "id": "navdropdown"
    }
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        _vm.changeDropdownState(false)
      }
    }
  }), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c(_vm.currentDropdownComponent, {
    tag: "component",
    on: {
      "close": function($event) {
        _vm.changeDropdownState(false)
      }
    }
  })], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ca0c76c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Navbar.vue
// module id = 44
// module chunks = 7